import { IDay } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { BookIcon } from '../../ui/components/Icons';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  isBookingTime: boolean;
  day: IDay;
  isSoloWorkout: boolean;
  startNow(): void;
  bookTime(): void;
  t(key: string): string;
}

export const StartTimeSelection: FunctionComponent<IProps> = ({ t,
  isBookingTime,
  day,
  isSoloWorkout,
  startNow,
  bookTime,
}) => {
  if (!day.isToday || !isSoloWorkout) {
    return null;
  }

  return (
    <View style={styles.container}>
      <SelectionContainer
        title={t('bookATime')}
        isSelected={isBookingTime}
        onPress={bookTime}
        style={{ marginRight: ButtonMargin }}
        icon={(
          <View style={styles.iconContainer}>
            <BookIcon
              width={40}
              height={40}
              color={isBookingTime ? Theme.WHITE : Theme.BLACK}
              styles={{ marginHorizontal: 5 }}
            />
          </View>
        )}
      />
      <SelectionContainer
        title={t('startNow')}
        isSelected={isBookingTime === false}
        onPress={startNow}
        style={{ marginLeft: ButtonMargin }}
        icon={(
          <View style={styles.iconContainer}>
            <Icon
              size={50}
              name={'ios-play-outline'}
              color={isBookingTime === false ? Theme.WHITE : Theme.CHARCOAL}
            />
          </View>
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  iconContainer: {
    width: 50,
    height: 50,
    alignItems: 'center',
  },
});
